var storage = require('storage')

// to pass data to React please keep the keys list updated in
// apps/react-webapp/src/modules/app/settings/features.ts
module.exports = Em.Controller.extend({
    fixedAssets: storageCp(),

    pbs: storageCp(),

    reactContacts: storageCp(),

    reactCreateContacts: storageCp(),

    bankAccounts: storageCp(),

    reactBankReconciliation: storageCp(),

    navigationMyClient: storageCp(),

    expertReviewEntries: storageCp(),

    invoicingSettings: storageCp(),

    reconciliationViewAsDefault: storageCp(),

    reports: storageCp(),

    expertReportsSuppliersBalance: storageCp(),

    expertReportsCustomersBalance: storageCp(),

    expertReportsTrialBalance: storageCp(),

    expertReportsProfitAndLoss: storageCp(),

    expertReportsBalanceSheet: storageCp(),

    expertReportsVatDeclarations: storageCp(),

    cashpilotReferenceDate: stringStorageCp(),

    cashPilotOpenBank: storageCp(),

    mastercardOpenFinance: storageCp(),

    actions: {
        toggle: function(feature) {
            this.toggleProperty(feature)
        }
    }
})

function makeCp(parse, serialize) {
    return Em.computed(function(key, value) {
        var storageKey = 'labs-flag:' + key
        if (arguments.length > 1) {
            var raw = serialize(value)

            if (raw) {
                storage(storageKey, raw)
            } else {
                storage.remove(storageKey)
            }

            return value
        }
        return parse(storage(storageKey))
    })
}

function storageCp() {
    return makeCp(parseBoolean, serializeBoolean)
}

function stringStorageCp() {
    return makeCp(parseString, serializeString)
}

function parseBoolean(value) {
    return value === '1'
}

function serializeBoolean(value) {
    return value ? '1' : null
}

function parseString(value) {
    return value || ''
}

function serializeString(value) {
    return value || null
}
